// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__6d5Tz","content":"LoadingAlert_content__3037y"};